import React from "react";

const HomeSellingGuidePage = () => {
  const sectionData = [
    {
      title: "7 Steps to Sell Your Home via Housing.in",
      description:
        "Selling your house can be a time-consuming experience, but with the right approach, you can sell your home quickly at the best price. Follow these simple steps for an easy home sale!",
      items: [
        {
          text: "Conduct Minor Repairs - Ensure your home is presentable and ready for potential buyers.",
          image: "/construction.png",
        },
        {
          text: "Hire A Real Estate Professional - Find a reliable real estate professional who can guide you through the process.",
          image: "/expert.png",
        },
        {
          text: "Set The Price - Setting the right selling price is crucial to attract the right buyers.",
          image: "/pricenegotiation.png",
        },
        {
          text: "Approach The Market - Use both online and offline advertising to reach as many buyers as possible.",
          image: "/market.png",
        },
        {
          text: "Prepare For Flat Showings - First impressions matter. Stage your property to make it attractive to buyers.",
          image: "/sitevisits.png",
        },
        {
          text: "Handle Negotiations Well - Be prepared for negotiations and aim for the best deal for your property.",
          image: "/legal.png",
        },
        {
          text: "Close The Sale Successfully - Once you’ve agreed on the price, the final step is to finalize the sale and complete the paperwork.",
          image: "/shortlist.png",
        },
      ],
    },
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl font-bold text-gray-800">
          Home Selling Guide with <span className="text-blue-600">Housing.in</span>
        </h1>
        <p className="text-gray-600 mt-2">
          Follow These Simple Steps for a Successful Home Sale
        </p>
      </header>

      {/* Sections */}
      {sectionData.map((section, index) => (
        <section key={index} className="my-8">
          <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            {section.description && (
              <p className="text-gray-600 mb-4">{section.description}</p>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {section.items.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center bg-gray-50 shadow-md rounded-lg p-4"
                >
                  <img
                    src={item.image}
                    alt={item.text}
                    className="w-16 h-16 rounded-full border-2 border-blue-500 mr-4"
                  />
                  <p className="text-gray-700">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default HomeSellingGuidePage;
